import _ from 'lodash';
import DragBox from 'ol/interaction/DragBox';
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import Snap from 'ol/interaction/Snap';
import Select from 'ol/interaction/Select';

const interactions = {
  dragbox: DragBox,
  draw: Draw,
  modify: Modify,
  snap: Snap,
  select: Select
}

export default (options) => {

  const olOptions = _.omit(options, ['on', 'interaction']);

  if(!interactions.hasOwnProperty(options.interaction)) throw new Error(`${options.interaction} is not a valid interaction`);

  const interaction = new interactions[options.interaction](olOptions);

  if(options.on && options.on.length){
    options.on.forEach((l) => {
      interaction.on(l.event, l.listener, l.scope);
    })
  }

  return interaction;
}